import { render, staticRenderFns } from "./ContaConfiguracaoPassword.vue?vue&type=template&id=55e60c0a&scoped=true&"
import script from "./ContaConfiguracaoPassword.vue?vue&type=script&lang=js&"
export * from "./ContaConfiguracaoPassword.vue?vue&type=script&lang=js&"
import style0 from "./ContaConfiguracaoPassword.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ContaConfiguracaoPassword.vue?vue&type=style&index=1&id=55e60c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e60c0a",
  null
  
)

export default component.exports